import { render, staticRenderFns } from "./creat-dict.vue?vue&type=template&id=c8882d7c"
import script from "./creat-dict.vue?vue&type=script&lang=js"
export * from "./creat-dict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports